export class Timer {
    constructor() {
        this.disposers = new Map();
        this.registeredId = 0;
    }
    wait(callback, duration) {
        // @ts-ignore TODO fix so node types does not interfere with DOM lib
        const timeout = setTimeout(callback, duration);
        const disposer = () => {
            clearTimeout(timeout);
        };
        return this.registerDisposer(disposer);
    }
    repeat(callback, duration, callOnceOnInvoke = false) {
        if (callOnceOnInvoke) {
            callback();
        }
        // @ts-ignore TODO fix so node types does not interfere with DOM lib
        const interval = setInterval(callback, duration);
        const disposer = () => {
            clearInterval(interval);
        };
        return this.registerDisposer(disposer);
    }
    flush() {
        this.disposers.forEach((disposer) => disposer());
    }
    registerDisposer(disposer) {
        let localUid = this.registeredId++;
        this.disposers.set(localUid, disposer);
        return () => {
            this.disposers.delete(localUid);
            disposer();
        };
    }
}
/**
 * ## cortex:std:timer
 * Wrapper around JavaScript's setTimeout and setInterval to provide a more
 * intuitive api interface
 */
(function (Timer) {
    function wait(...args) {
        const time = new Timer();
        time.wait(...args);
        return time.flush.bind(time);
    }
    Timer.wait = wait;
    function repeat(...args) {
        const time = new Timer();
        time.repeat(...args);
        return time.flush.bind(time);
    }
    Timer.repeat = repeat;
})(Timer || (Timer = {}));
